// extracted by mini-css-extract-plugin
export default {"imageWrapper":"JF-z","hovered":"KF-z","hoverImage":"LF-z","mainImage":"MF-z","imageNoBackground":"NF-z","fullSizeImage":"OF-z"};